import EmptyWrap from "@/components/Gui/EmptyWrap";

export default [
    {
        path: 'report',
        component: EmptyWrap,
        children: [
            {
                path: '',
                name: 'report.list',
                component: require('@/views/Report/ReportList').default,
            },
        ]
    },
]